// src/top50/index.js — Top 50 module entry point
//
// This file is the bundler entry. esbuild reads from here and
// follows imports to produce dist/top50.js as an IIFE bundle with
// global name `Top50`. The HTML loads that bundle and calls
// Top50.admin.foo() / Top50.staff.foo() / Top50.shared.foo().
//
// Phase 1 (this commit): stub. The three sub-namespaces export
// nothing yet. Phase 2 will fill in the real logic.

import * as admin  from './admin.js';
import * as staff  from './staff.js';
import * as shared from './shared.js';

export { admin, staff, shared };
